<template>
    <div>
        <div class="vx-col border border-solid d-theme-border-grey-light rounded-lg relative overflow-hidden bg-white p-2 shadow-drop">
            <vs-tabs alignment="fixed"
                v-model="tab">
                <vs-tab :label="isSmallerScreen ? '' : 'Detalhes'" icon-pack="feather" icon="icon-edit">
                    <div class="pt-4">
                        <product-details />
                    </div>
                </vs-tab>
                <vs-tab :label="isSmallerScreen ? '' : 'Estoque'" icon-pack="feather" icon="icon-package">
                    <div class="pt-4">
                        <product-stock />
                    </div>
                </vs-tab>
                <vs-tab :label="isSmallerScreen ? '' : 'Preço'" icon-pack="feather" icon="icon-dollar-sign">
                    <div class="pt-4">
                        <product-price @unicPrice="val => isUnicPrice = val" />
                    </div>
                </vs-tab>
                <vs-tab :label="isSmallerScreen ? '' : 'Opções'" icon-pack="feather" icon="icon-settings">
                    <div class="pt-4">
                        <product-options />
                    </div>
                </vs-tab>
                <vs-tab :label="isSmallerScreen ? '' : 'Fiscal'" icon-pack="feather" icon="icon-file-text">
                    <div class="pt-4">
                        <product-fiscal />
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>

        <div class="flex w-full justify-between">
          <vs-button class="mt-4" color="warning" icon-pack="feather" icon="icon-trash" @click="removeProduct" v-if="productId"> Remover </vs-button>
          <vs-button class="mt-4" icon-pack="feather" icon="icon-save" @click="save"> Salvar </vs-button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import ProductDetails from '@/components/product/ProductDetails'
    import ProductStock from '@/components/product/ProductStock'
    import ProductPrice from '@/components/product/ProductPrice'
    import ProductOptions from '@/components/product/ProductOptions'
    import ProductFiscal from '@/components/product/ProductFiscal'
    import firebase from '@/firebase/firebase'
    import _misc from '@/assets/utils/misc'
    import * as imageConversion from 'image-conversion'

    import productActionsMixin from './productActionsMixin';

    const ref = firebase.firestore()
    var batch = ref.batch()

    export default {
        mixins: [productActionsMixin],
        props : {
            productId : {
              required : false,
              type : String
            }
        },

        components : {
            ProductFiscal,
            ProductOptions,
            ProductPrice,
            ProductStock,
            ProductDetails
        },

        data () {
            return {
                companyId : this.$store.getters.getCompanyID,
                isUnicPrice : true,
                tab: 0
            }
        },

        computed : {
            isSmallerScreen() {
                return this.$store.state.windowWidth < 768
            },
            ...mapState('product', ['productInfo', 'tempImageBase64'])
        },

        mounted () {
            if(this.productId) {
              this.setProductId(this.productId)
              this.getProductData()
            } else {
              this.reset();
            }
        },

        methods : {
            async getProductData () {
                try {
                    if(!this.productId) return
                    
                    this.$vs.loading()
                    let product = await ref.collection(`/company/${this.companyId}/products/`).doc(this.productInfo.id).get()
                    let productData = product.data()

                    if(product.empty) 
                        return

                    this.oldProductTypeId = productData.productType.id
                    this.setProductInfo(productData)
                    this.setProductId(this.productId)
                    this.isUnicPrice = !!productData.value;
                } catch (err) {
                    this.$error({
                        zIndex: 999999,
                        title: 'Erro',
                        content : `Erro ao obter produto: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            async save () {
                try {
                    let validate = this.validateFields()
                    if(validate){
                        this.$error({
                            zIndex: 999999,
                            title: 'Erro',
                            content : `Erro ao salvar produto: ${validate}`
                        });
                        return;
                    }

                    const confirmed = await this.warnPriceIfNone();
                    if (!confirmed)
                        return;

                    this.$vs.loading()

                    let productRef = ref.collection(`/company/${this.companyId}/products/`).doc(this.productInfo.id);
                    
                    this.savePriceCorrectly()
                    
                    if(!this.productInfo.hasOwnProperty('cod')) {
                      let currentCod = await this.autoIncrementCod()
                      this.setProductCod(currentCod)
                    }

                    await this.uploadImg() // uploads and set image url to store

                    if(!this.productId) {
                        batch.set(productRef, this.productInfo)
                    } else {
                        batch.update(productRef, this.productInfo)
                        await this.removeFromProductType(this.productInfo.id)
                    }

                    await this.insertOrUpdateProductInOption(this.productInfo.id)
                    await this.insertOrUpdateProductType(this.productInfo.id)

                    await batch.commit()
                    batch = ref.batch()
                    
                    this.$success({
                        zIndex: 999999,
                        title: 'Sucesso',
                        content : `Produto salvo com sucesso!`
                    })
                    this.reset();
                } catch (err){
                    this.$store.commit('setError', err);
                } finally {
                    this.$vs.loading.close()
                }
            },

            uploadImg () {
              return new Promise(async (resolve, reject) => {
                try {
                  if(!this.tempImageBase64) resolve(false)

                  const convertedImg = await this.convertToJPG(this.tempImageBase64)
                  var imageName = _misc.generateId(50);
                  const pTypeNameAndId = this.getPTypeNameAndId()
                  const child = `${this.companyId}/${pTypeNameAndId}/jpg/${imageName}.jpeg`
                  var storageRef = firebase.app().storage('gs://pedido-rapido-catalog').ref().child(child)

                  var that = this;
                  var metadata = {
                    contentType: 'image/jpeg',
                    cacheControl: 'max-age=31536000'
                  };

                  let uploadTask = storageRef.put(convertedImg, metadata)
                  
                  uploadTask.on('state_changed', function (snapshot) {
                      that.uploadingImage = true;
                      that.imageUploadPercent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    }, function (error) {
                      that.$vs.loading.close();
                      reject(new Error(`Houve um erro desconhecido ao processar o upload: ${error}`));
                    }, async function () {
                      let url = await uploadTask.snapshot.ref.getDownloadURL()

                      that.setImage(url)

                      resolve(url)
                    }
                  )
                }catch(err) {
                  reject(new Error(`Houve um erro ao processar o upload: ${err.message}`))
                }
              })
            },

            getPTypeNameAndId () {
              return `${this.productInfo.productType.description}-${this.productInfo.productType.id}`
            },

            async convertToJPG (base64image) {
                var imgBlob = await imageConversion.dataURLtoFile(base64image)
                const convertedImg =  await imageConversion.compress(imgBlob, {
                    quality: 0.7,
                    type: 'image/jpeg'
                });
                return convertedImg
            },

            savePriceCorrectly () {
                if(this.isUnicPrice) {
                    if(!this.productInfo.hasOwnProperty('options')) return
                    if(this.productInfo.options.hasOwnProperty('size')) {
                        this.removeSizeOption()
                    }
                } else {
                    this.setProductValue(0)
                }
            },

            validateFields () {
                if(!this.productInfo.description) return 'Entre com o nome do produto corretamente!'
                if(this.productInfo.productType && !this.productInfo.productType.menuId) return 'Selecione um menu!' 
                if(this.productInfo.productType && !this.productInfo.productType.id) return 'Selecione uma categoria!' 
            },

            warnPriceIfNone () {
                return new Promise((res, _) => {
                    if ((this.isUnicPrice && !this.productInfo.value) // no fixed value
                    || (!this.isUnicPrice && (!this.productInfo.options.size || !Object.values(this.productInfo.options.size.items).reduce((prev, curr) => prev + curr.value, 0)))) // no price in sizes
                        this.$confirm({
                            title: 'Produto sem preço definido!',
                            content: 'Pode ser que o preço esteja apenas opções. Tem certeza que deseja salvar assim?',
                            onOk: () => { res(true) },
                            onCancel: () => { res(false) },
                            cancelText: 'Cancelar'
                        })
                    else
                        res(true);
                });
            },

            async autoIncrementCod () {
                let increment = ref.collection(`/company/${this.companyId}/counters/`).doc('products');
                let hasDoc = await increment.get()

                if(!hasDoc.exists) {
                    await increment.set({ current : firebase.firestore.FieldValue.increment(1) })
                } else {
                    await increment.update({ current : firebase.firestore.FieldValue.increment(1) })
                }                        
                
                let current = await increment.get()
                let result = current.data()
                return result.current;
            },

            async insertOrUpdateProductInOption (productId) {
                try {
                    let objProductOptionsId = []
                    if(this.productInfo.hasOwnProperty('options'))
                        Object.entries(this.productInfo.options).forEach(option => {
                            if(option[0] != "size") objProductOptionsId.push(option[0])
                        })

                    let colRef = ref.collection(`/company/${this.companyId}/productInOption/`).doc(productId)
                    batch.set(colRef, {options: objProductOptionsId})
                } catch (err) {
                    this.$error({
                        title: 'Erro inesperado',
                        content : `Erro ao tentar inserir produto dentro de opções ${err.message}`
                    })
                }
            },

            async removeFromProductType(productId) {
                var companyID = this.$store.getters.getCompanyID

                try {
                    let companyProductTypes = await ref.collection('company').doc(companyID).collection('productType').doc(this.oldProductTypeId).get()
                    let productTypes = companyProductTypes.data()

                    if (productTypes.hasOwnProperty('products')) {
                        delete productTypes.products[productId];
                    }

                    let pTypeRef = ref.collection('company').doc(companyID).collection('productType').doc(this.oldProductTypeId);
                    batch.update(pTypeRef, productTypes)
                } catch (err) {
                    this.$error({
                        title: 'Erro inesperado',
                        content : `Erro ao tentar excluir o tipo de produto. ${err.message}`
                    })
                }
            },

            async removeProduct() {
                const { productInfo } = this;
                await this.deleteProduct(productInfo.id, productInfo.productType.id);
                this.$router.back();
            },
            async insertOrUpdateProductType (productId) {
                var selectedProductType = this.productInfo.productType;

                try {
                    let companyProductTypes = await ref.collection('company').doc(this.companyId).collection('productType').doc(selectedProductType.id).get()
                    let productTypes = companyProductTypes.data()
                    const hours = productTypes.products[productId] ? productTypes.products[productId].hours : {}

                    let productTypeObj = {
                        description: this.productInfo.description || '',
                        details: this.productInfo.details || '',
                        id: productId,
                        image: this.productInfo.image || '',
                        priceDescription : '',
                        enabled : this.productInfo.enabled,
                        hours : hours || {},
                    }

                    if(this.productInfo.hasOwnProperty('cod'))
                        productTypeObj.cod = this.productInfo.cod;
                    if(!productTypes.products[productId]) // if is a new product, add at last in order
                        productTypeObj.order = Object.values(productTypes.products).length;
                    else
                        productTypeObj.order = productTypes.products[productId].order;

                    const priceDesc = this.getProductTypePriceDesc()
                    if(priceDesc)
                        productTypeObj.priceDescription = `R$ ${priceDesc.toFixed(2).replace('.',',')}`
                    productTypes.products[productId] = productTypeObj;

                    let pTypeRef = ref.collection('company').doc(this.companyId).collection('productType').doc(selectedProductType.id)
                    batch.update(pTypeRef, productTypes)

                    this.oldProductTypeId = selectedProductType.id;
                    return true;
                } catch (err) {
                    this.$error({
                        title: "Erro inesperado",
                        content: `Erro inesperado ao tentar salvar tipo de produto. ${err.message}}`
                    })

                    return false;
                }
            },

            getProductTypePriceDesc () {
                let lowestPrice = 0;
                if(this.productInfo.options.hasOwnProperty('size'))
                    lowestPrice += this.getLowestSizePrice()
                else
                    lowestPrice += this.productInfo.value;

                return lowestPrice
            },

            getLowestSizePrice () {
                let sizes = this.productInfo.options.size.items
                let lowestPrice = 0;
                for (let size in sizes) {
                    if(lowestPrice == 0) lowestPrice = sizes[size].value
                    lowestPrice = lowestPrice > sizes[size].value ? sizes[size].value : lowestPrice
                }
                return lowestPrice
            },

            reset () {
                this.clearProductInfo();
                this.setProductId(_misc.generateId(21))
                this.tab = 0;
                this.isUnicPrice = true;
                this.clearImage();
            },
            clearImage () {
                this.setTempImage(null)
                this.setTempImageBase64(null)
                this.setImage(null);
            },

            ...mapMutations('product', ['setProductCod', 'setProductInfo', 'setProductValue', 'removeSizeOption', 'clearProductInfo', 'setProductId', 'setImage', 'setTempImage', 'setTempImageBase64'])
        },
        beforeDestroy () {
            this.clearImage();
        }
    }
</script>